import React from "react";

//components
import TimePicker from "react-time-picker";
import { IconLibrary, ThriveIcon } from "thrive-components";

//styles
import "react-time-picker/dist/TimePicker.css";
import "react-clock/dist/Clock.css";
import "../../../css/global/BasicTimePicker.scss";


const BasicTimePicker = ({
  selectedTime,
  setSelectedTime,
  hasError,
  defaultTime,
}) => {
  
  function onTimeSelection(value: string) {
    setSelectedTime(value);
  }

  return (
    <div className={`${hasError ? `time-error` : ``} input time-picker`}>
      <TimePicker
        data-testid="time-picker-component"
        onChange={(value) => onTimeSelection(value)}
        disableClock={true}
        hourPlaceholder={defaultTime.slice(0,2)}
        minutePlaceholder={defaultTime.slice(3)}
        value={selectedTime}
        format='HH:mm'
        clockAriaLabel="Select Time"
        nativeInputAriaLabel="Select Time"
        hourAriaLabel="Select Hour"
        minuteAriaLabel="Select Minutes"
      />

      <ThriveIcon 
        className="clock-icon"
        iconName={IconLibrary.CLOCK}
        sizeInPx="16"
        color="var(--thriveGreyDark)"  
      />
    </div>
  );
};
export default BasicTimePicker;
